import { HtmlResize } from "@logicflow/extension";

export default function registerPosition (lf) {
    lf.register('circlenew', () => {
        class ConnectNode extends  HtmlResize.view {

            setHtml(rootEl) {
                rootEl.innerHTML = "";
                rootEl.setAttribute("class", "node_circle ");
                rootEl.style.background="#f9f9f9"
                rootEl.style.border="1px solid #f1a131"
                 const { properties } = this.props.model;
                this.props.model._height=this.props.model._width;
                 // const {nodeSize} =properties;
                // nodeSize.height=nodeSize.width;
                // rootEl.style.height=nodeSize.height;

                 const container = document.createElement("div");
                container.style.height="100%"
                const itemhead = document.createElement("div");
                itemhead.className = "";
                itemhead.style.background="#f9f9f9"
                itemhead.style.height="30%"
                container.appendChild(itemhead);
                const itemElement = document.createElement("div");
                itemElement.className = "";
                itemElement.style.background="#6c98ad"
                itemElement.style.height="70%"
                container.appendChild(itemElement);
                 rootEl.appendChild(container);


                // new Profile().$mount(el)
            }
        }
        class ConnectNodeModel extends HtmlResize.model {
            setAttributes(){
                if (this.hasOwnProperty("properties")) {
                    let data = this.properties;
                    if (data && data.hasOwnProperty("nodeSize")) {
                        const {nodeSize} = data;
                        let tt=this.text?this.text:{value:'',x:0,y:0}
                        tt = {
                            value:  tt.value||'',
                            x: this.x  ,
                            y: this.y  - nodeSize.height / 2 + 25
                        }
                        this.text=tt;
                    }
                }
            }
            initNodeData(data) {
                super.initNodeData(data);
                this.width = 150;
                this.height = 150;
                const properties = this.getProperties()


            }
            getNodeStyle() {
                const style = super.getNodeStyle();

                style.fill = "#f1a131";
                style.stroke="#6c98ad";
                style.strokeWidth = 5;
                style.strokeDasharray = "3 3";
                if (this.isSelected) {
                    style.stroke = "rgb(124, 15, 255)";
                }
                return style;
            }
            getAnchorStyle() {
                const style = super.getAnchorStyle();
                style.stroke = "transparent";
                style.fill = "none";
                style.hover.stroke = "transparent";
                return style;
            }
        }
        return {
            view: ConnectNode,
            model: ConnectNodeModel
        }
    })
}